import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useQuery, useMutation } from "@apollo/client";
import { format } from "date-fns";
import { BLOG, DELETE_BLOG } from "../../gql/blog";
import {
  Breadcrumbs,
  Typography,
  Box,
  Paper,
  Card,
  CardHeader,
  CardContent,
  CardMedia,
  ListItem,
  ListItemText,
  CardActions,
  Button,
  Modal,
  Alert,
  Divider,
} from "@mui/material";
import UpdateBlog from "../../components/blogs/UpdateBlog";
import { DELETE_MUSCLE_TYPE, MUSCLE_TYPES_PK } from "../../gql/muscleTypes";
import UpdateMuscleType from "../../views/muslceTypes/UpdateMuscleType";
import { LoadingModal } from '../../components/layout';
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100vw",
  height: "100vh",
  overflow: "scroll",
  bgcolor: "background.paper",
  // border: "2px solid #000",
  boxShadow: 24,
};
const styleR = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 350,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const MuscleType = ({ homeAlert }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const result = useQuery(MUSCLE_TYPES_PK, { variables: { id: id } });
  const [showAlert, setShowAlert] = useState({ message: "", isError: false });
  const [openU, setOpenU] = useState(false);
  const [openR, setOpenR] = useState(false);
  const [muscleType, setMuscleType] = useState();
  const blogAlert = (message, isError = false) => {
    setShowAlert({ message: message, isError: isError });
    setTimeout(() => {
      setShowAlert({ message: "", isError: false });
    }, 3000);
  };

  const [deleteBlog] = useMutation(DELETE_MUSCLE_TYPE, {
    onError: (error) => {
      console.log(error);
      setShowAlert({ message: "Error on server", isError: true });
      setTimeout(() => {
        setShowAlert({ message: "", isError: false });
      }, 3000);
    },
    onCompleted: () => {
      alert("Muscle Type has been removed");
      navigate(-1);
    },
  });

  if (result.loading) {
    return <LoadingModal open message="Loading..." />;
  }

  const handleOpenU = (data) => {
    setOpenU(true);
    setMuscleType(data);
  };
  const handleCloseU = () => setOpenU(false);
  const handleOpenR = () => setOpenR(true);
  const handleCloseR = () => setOpenR(false);

  const blog = result.data.muscle_types_by_pk;

  const handleDelete = () => {
    let image_url = blog?.image_url;
    let image_name = image_url?.substring(
      image_url?.lastIndexOf("/") + 1,
      image_url?.lenght
    );
    deleteBlog({ variables: { id: blog.id, image_name: image_name } });
  };

  return (
    <div>
      <div role="presentation">
        <Breadcrumbs aria-label="breadcrumb">
          <Link to="/user" className="dashboard">
            Dashboard
          </Link>
          <Link to="/muscleType" className="dashboard">
            Muscle Type
          </Link>
          <span>{id}</span>
        </Breadcrumbs>
      </div>
      <Typography variant="h6" component="h2" sx={{ my: 3, color: "black" }}>
        MuscleType Details
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1.2fr" },
          gap: 3,
          mb: 2.5,
          alignItems: "start",
        }}
      >
        {/* Left Column: Image Card */}
        {blog?.image_url && blog?.image_url !== "null" ? (
          <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)", overflow: "hidden" }}>
            <CardMedia
              component="img"
              sx={{ width: "100%", height: "auto", display: "block" }}
              image={blog.image_url}
              alt={blog.name}
            />
          </Card>
        ) : (
          <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)", p: 4, display: "flex", justifyContent: "center", bgcolor: "#fafafa" }}>
            <Typography color="text.secondary">No Image Available</Typography>
          </Card>
        )}

        {/* Right Column: Key Info and Actions */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Key Information Card */}
          <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)", p: 2 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1, px: 2 }}>
              Key Information
            </Typography>
            <Divider />
            <Box sx={{ mt: 1 }}>
              <ListItem>
                <ListItemText primary="ID" secondary={blog?.id} />
              </ListItem>
              <ListItem>
                <ListItemText primary="Name" secondary={blog?.name} />
              </ListItem>
              <ListItem>
                <ListItemText
                  primary="Created At"
                  secondary={
                    blog?.created_at &&
                    format(new Date(blog.created_at), "yyyy-MM-dd hh:mm:ss a")
                  }
                />
              </ListItem>
            </Box>
          </Card>

          {/* Actions Card */}
          <Card sx={{ borderRadius: "12px", border: "1px solid #eee", boxShadow: "0 1px 4px rgba(0, 0, 0, 0.04)" }}>
            <CardActions sx={{ display: "flex", justifyContent: "flex-end", p: 2, gap: 2 }}>
              <Button
                onClick={() => handleOpenU(blog)}
                color="primary"
                variant="contained"
              >
                Edit
              </Button>
              <Button
                onClick={handleOpenR}
                color="error"
                variant="contained"
              >
                Remove
              </Button>
            </CardActions>
          </Card>
        </Box>
      </Box>
      <Modal
        keepMounted
        open={openR}
        onClose={handleCloseR}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={styleR}>
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2">
            Confirmation
          </Typography>
          <Typography id="keep-mounted-modal-description" sx={{ mt: 2 }}>
            Are you sure want to remove this blog?
          </Typography>
          <Box sx={{ textAlign: "right", mt: 2 }}>
            <Button color="secondary" onClick={handleCloseR}>
              Cancel
            </Button>
            <Button onClick={handleDelete}>Confirm</Button>
          </Box>
        </Box>
      </Modal>
      <div style={{ minHeight: "auto" }}>
        <Modal
          open={openU}
          onClose={handleCloseU}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={{ width: "100vw" }}
        >
          <Box sx={style}>
            <UpdateMuscleType
              muscleType={muscleType}
              handleClose={handleCloseU}
              // blogAlert={blogAlert}
            />
          </Box>
        </Modal>
      </div>
      {showAlert.message && !showAlert.isError && (
        <Alert
          sx={{ position: "fixed", bottom: "1em", right: "1em" }}
          severity="success"
        >
          {showAlert.message}
        </Alert>
      )}
      {showAlert.message && showAlert.isError && (
        <Alert
          sx={{ position: "fixed", bottom: "1em", right: "1em" }}
          severity="warning"
        >
          {showAlert.message}
        </Alert>
      )}
    </div>
  );
};

export default MuscleType;
